export default "__VITE_ASSET__CnN4LrNL__"